<template>
    <div>
        <Loading2
            :isLoading="isLoading"
            :textList="['LOADING...','正在核對身份','連線讀取資料中']"
        >
            <div class="loading-animation scale-50">
                <div />
                <div />
                <div />
            </div>
            <p class="pb-2 text-gray-900 text-lg font-bold">
                前往線上交易專區
            </p>
        </Loading2>
    </div>
</template>

<script>
import { onMounted, ref, inject } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import Loading2 from '@/components/Loading2.vue';
import { getInfoIQ } from '@/apis/IQ.js';
import routeName from '@/router/constant.js';

export default {
    components: {
        Loading2,
    },
    setup() {
        const $vfm = inject('$vfm');
        const isLoading = ref(false);
        const router = useRouter();
        const store = useStore();

        const showPopup = () => {
            $vfm.show({
                component: 'DialogBase',
                params: {
                    title: '很抱歉',
                    content: '系統忙碌中，請稍後再試',
                    confirmButton: '前往首頁',
                    closeicon: false,
                },
                on: {
                    confirm() {
                        router.push({ name: routeName.HOME });
                        $vfm.hide('DialogBase');
                    },
                }
            });
        };
        // invq-redirect?questNo=2023030800021
        const { questNoIQ, fromIQRedirect } = store.state.services;
        if (questNoIQ) {
            getInfoIQ(questNoIQ).then(res => {
                store.dispatch('services/setChangeItemsResult', { code: 'IQ', value: res.data.investType });
                router.push({ name: fromIQRedirect });
            }).catch(() => {
                showPopup();
            });
        }

        onMounted(() => {
            isLoading.value = true;
        });

        return {
            isLoading
        };
    }
};
</script>
